import { Flex, Typography } from "antd"
import React, { type ReactNode } from "react"

const { Title, Text } = Typography

/**
 * The icon-box + title + subtitle header every Calendar create/edit form
 * modal shares — `CalendarAddForm`'s own "Create New Event", `CalendarView`'s
 * "Edit Event", and (now) the Lead/Project workspace's appointment and
 * follow-up editors. One place so the three can't drift the way the header
 * itself once did between the workspace and the Calendar page.
 */
export function calendarFormModalHeader(
  icon: ReactNode,
  title: string,
  subtitle: string
) {
  return (
    <Flex align={"center"} gap={12} className={"pr-6"}>
      <Flex
        align={"center"}
        justify={"center"}
        className={"size-11 shrink-0 rounded-xl bg-teal-50"}
      >
        {icon}
      </Flex>
      <div>
        <Title level={4} className={"mb-0 text-start"}>
          {title}
        </Title>
        <Text type={"secondary"} className={"text-sm"}>
          {subtitle}
        </Text>
      </div>
    </Flex>
  )
}
